import vue from 'vue'
import AuthApi from './auth'
import CategoriesApi from './categories'
import ChannelsApi from './channels'
import EmotesApi from './emotes'
import ImagesApi from './images'
import ThreadsApi from './threads'
import RepliesApi from './replies'
import SelfApi from './self'
import UsersApi from './users'

vue.prototype.$api = {
  auth: AuthApi,
  categories: CategoriesApi,
  channels: ChannelsApi,
  emotes: EmotesApi,
  images: ImagesApi,
  threads: ThreadsApi,
  replies: RepliesApi,
  self: SelfApi,
  users: UsersApi
}
